(() => {
  const init = (root) => {
    if (!root || !root.matches('[data-tan-office-wall]') || root.dataset.officeWallReady) return;
    root.dataset.officeWallReady = 'true';

    const preview = root.querySelector('[data-office-wall-preview]');
    const choices = Array.from(root.querySelectorAll('[data-office-zone-choice]'));
    const ambient = root.querySelector('[data-office-ambient]');
    const ambientValue = root.querySelector('[data-office-ambient-value]');
    const resultHeading = root.querySelector('[data-office-zone-heading]');
    const resultCopy = root.querySelector('[data-office-zone-copy]');
    const resultList = root.querySelector('[data-office-zone-list]');

    const updateChoice = (choice) => {
      if (!choice || !preview) return;
      choices.forEach((item) => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });

      preview.dataset.mode = choice.dataset.modeKey || 'reception';
      if (resultHeading) resultHeading.textContent = choice.dataset.zoneTitle || '';
      if (resultCopy) resultCopy.textContent = choice.dataset.zoneNote || '';

      const payload = root.querySelector(`[data-office-zone-payload="${CSS.escape(choice.dataset.zoneId || '')}"]`);
      const content = payload?.content.querySelector('[data-office-zone-checklist]');
      if (resultList && content) resultList.innerHTML = content.innerHTML;

      ['viewer', 'constraint', 'evidence'].forEach((metric) => {
        const label = root.querySelector(`[data-office-metric-label="${metric}"]`);
        const value = root.querySelector(`[data-office-metric-value="${metric}"]`);
        if (label) label.textContent = choice.dataset[`${metric}Label`] || '';
        if (value) value.textContent = choice.dataset[`${metric}Value`] || '';
      });
    };

    const updateAmbient = () => {
      if (!ambient || !preview) return;
      const strength = Number(ambient.value) / 100;
      preview.style.setProperty('--office-daylight', String(0.08 + strength * 0.52));
      preview.style.setProperty('--office-glow', String(0.72 + (1 - strength) * 0.28));
      preview.style.setProperty('--office-room-light', String(0.18 + strength * 0.62));
      if (ambientValue) ambientValue.textContent = `${ambient.value}%`;
    };

    choices.forEach((choice) => choice.addEventListener('click', () => updateChoice(choice)));
    ambient?.addEventListener('input', updateAmbient);
    updateAmbient();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-tan-office-wall]')) init(scope);
    scope.querySelectorAll?.('[data-tan-office-wall]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
